/* eslint-disable jsx-a11y/alt-text */
import { ErrorToast } from "app/shared/components/Popups/ToastMessage";
import Url from "app/shared/constants/Url";
import axios from "axios";
import _ from "lodash";
import moment from "moment";
import React, { Component } from "react";
import "react-datepicker/dist/react-datepicker.css";
import FsLightbox from "fslightbox-react";
import { Link } from "react-router-dom";
import { Row, Col, Modal } from "react-bootstrap";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

//assets
import { Calendar, X } from "react-feather";
import { KanbanListTypeIcon, KanbanGridIcon } from "assets/Iconsv2/Iconsv2";
//components
import VideoBox from "app/shared/components/ReusableComponents/VideoPlayer/container";
import ClideLoader from "app/shared/ui-kit/loader";
import ListInprogressSection from "../components/list/inprogressSection";
import ListCompletedSection from "../components/list/completedSection";
import ListPendingSection from "../components/list/pendingSection";
import NmListHelpDrawer from "../../NmList/NmListHelpDrawer";
//constants
import { nmContent } from "../constants/nmConstant";
import { withTranslation } from 'react-i18next';
import { compose } from 'redux';

import CompanyList from "app/shared/components/ReportModal/CompanyList";
import CommonDropdown from "app/shared/components/ReportModal/CommonDropdown";

const qs = require("qs");

class NmListV2 extends Component {
  constructor(props) {
    super(props);
    const{t}=this.props;
    this.state = {
      ...nmContent(t).listPageState(this.props),
      orgSettings: { company: true, category: true },
    };

    this.selectSeverity = this.selectSeverity.bind(this);
    this.child = React.createRef();
  }

  componentDidMount() {
    this._fetchOrganisationSettings();
    if (this.props._getNMList) this.props._getNMList(1);
    if (this.props._getNMProgressList) this.props._getNMProgressList(1);
    if (this.props._getNMCompletedList) this.props._getNMCompletedList(1);
    this._getService();
    this._fetchCompanyList();
    this._fetchCategoryList();
  }

  _fetchOrganisationSettings = async () => {
    try {
      let hostname = window.location.hostname;
      let db = "qaclide";
      if (hostname.includes(".")) {
        db = hostname.split(".")[0] || "qaclide";
      }
      const orgRes = await axios.get(Url.organisationSettingByDb, {
        params: { db }
      });
      if (orgRes.data && orgRes.data.data) {
        const orgData = orgRes.data.data;
        const isOrgOn = orgData.organisationSetting !== false;
        this.setState({
          orgSettings: {
            company: isOrgOn && (orgData.company !== false && orgData.companySetting !== false && orgData.companyName !== false),
            category: isOrgOn && (orgData.category !== false && orgData.categorySetting !== false && orgData.categoryName !== false && orgData.projectCategory !== false)
          }
        });
      }
    } catch (err) {
      console.error("Error fetching organisation settings:", err);
    }
  };

  _fetchCompanyList = async () => {
    let params = {
      page: 0,
      size: 200,
      search: "",
      softdelete: 0,
      softDelete: 0,
    };
    import("app/shared/utility/UtilFunction").then((utilFunction) => {
      let responseObj = utilFunction.sharedAxiosAPIGet(Url.companyList, params);
      responseObj
        .then(async (response) => {
          if (response.data && response.data.data) {
            await this.setState({ companyList: response.data.data });
          }
        })
        .catch((error) => console.error("Error fetching companies:", error));
    });
  };

  _fetchCategoryList = async () => {
    import("app/shared/utility/UtilFunction").then((utilFunction) => {
      let responseObj = utilFunction.sharedAxiosGETAPI(Url.subVerticalList);
      responseObj
        .then(async (response) => {
          if (response.data && response.data.data) {
            await this.setState({ categoryList: response.data.data });
          }
        })
        .catch((error) => console.error("Error fetching categories:", error));
    });
  };

  pendingModal = (visible) => {
    if (!visible) {
      this.setState({ pendingPopup: false });
      return;
    }
    if (this.props.nmPending?.length || this.state.isFilterApplied) {
      this.setState({ pendingPopup: visible, isFilterApplied: true });
    } else {
      ErrorToast("Filter Can't apply on empty list");
    }
  };

  inProgressModal = (visible) => {
    if (!visible) {
      this.setState({ inProgressPopup: false });
      return;
    }
    if (this.props.nmProgress?.length || this.state.isProgressFilterApplied) {
      this.setState({
        inProgressPopup: visible,
        isProgressFilterApplied: true,
      });
    } else {
      ErrorToast("Filter Can't apply on empty list");
    }
  };

  completedModal = (visible) => {
    if (!visible) {
      this.setState({ completedPopup: false });
      return;
    }
    if (this.props.nmCompleted?.length || this.state.isCompletedFilterApplied) {
      this.setState({
        completedPopup: visible,
        isCompletedFilterApplied: true,
      });
    } else {
      ErrorToast("Filter Can't apply on empty list");
    }
  };

  handleChange = (date) => {
    this.setState({
      startDate: date,
    });
  };

  _getNMList = async () => {
    this.setState({ moreDataLoading: true });
    let userId = localStorage.getItem("userId");
    let token = localStorage.getItem("springToken");

    let data;
    data = new FormData();

    data.append("auth_key", token);
    data.append("user_id", userId);
    await axios
      .post(Url.nmModule.nmList, data, {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
        params: {
          auth_key: token,
          user_id: userId,
        }
      })
      .then((response) => {
        if (response.data.status == 200) {
          this.setState({
            progress: response.data.data.inprogressnm.nm_basic_info,
            pending: response.data.data.pendingnm.nm_basic_info,
            completed: response.data.data.completednm.nm_basic_info,
            dataLoading: false,
          });
          this.props.nmlistfilter(
            this.state.pending,
            this.state.progress,
            this.state.completed
          );
        }
        // console.log(response.data.data)
      })
      .catch((error) => { })
      .finally(() =>
        this.setState({
          dataLoading: false,
        })
      );
  };

  _getService = async () => {
    let userId = localStorage.getItem("userId");
    let token = localStorage.getItem("token");
    await axios
      .post(
        Url.serviceList,
        qs.stringify({
          auth_key: token,
          user_id: userId,
        }),
        {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
          },
        }
      )
      .then((response) => {
        if (response.data.status == 200) {
          this.setState({
            service: response.data.data,
            pendingService: response.data.data,
            inProgressService: response.data.data,
            completedService: response.data.data,
            dataLoading: false,
          });
          if (this.state.dflag.designation_flag == 4) {
            var serviceobs = this.state.service.map((item) => item.service_id);
            this.setState({ serviceSelect: serviceobs[0] });
            this._getProject("pending", serviceobs[0]);
            this._getProject("progress", serviceobs[0]);
            this._getProject("completed", serviceobs[0]);
          }
        }
      })
      .catch((error) => {
        throw error;
      });
  };

  _fetchServiceForSection = async (companyId = null, section = "all") => {
    let userId = localStorage.getItem("userId");
    let token = localStorage.getItem("token");
    let payload = {
      auth_key: token,
      user_id: userId,
    };
    if (companyId) {
      payload.company_id = companyId;
      payload.companyId = companyId;
    }
    await axios
      .post(
        Url.serviceList,
        qs.stringify(payload),
        {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
          },
        }
      )
      .then((response) => {
        if (response.data && response.data.status == 200) {
          const list = response.data.data || [];
          if (section === "pending") {
            this.setState({ pendingService: list });
          } else if (section === "progress") {
            this.setState({ inProgressService: list });
          } else if (section === "completed") {
            this.setState({ completedService: list });
          } else {
            this.setState({
              service: list,
              pendingService: list,
              inProgressService: list,
              completedService: list,
            });
          }
        }
      })
      .catch((error) => console.error("Error fetching services for company:", error));
  };

  _getProject = async (
    type = "pending ",
    serviceId = this.state.pendingServiceSelect
  ) => {
    let userId = localStorage.getItem("userId");
    let token = localStorage.getItem("token");

    await axios
      .post(
        Url.projectList,
        qs.stringify({
          auth_key: token,
          user_id: userId,
          service_id: serviceId,
        }),
        {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
          },
        }
      )
      .then((response) => {
        if (response.data.status == 200) {
          switch (type) {
            case "pending":
              this.setState({
                pendingProject: response.data.data,
                dataLoading: false,
              });
              if (this.state.dflag.designation_flag == 4) {
                var projectobs = this.state.pendingProject.map(
                  (item) => item.project_id
                );
                this.setState({ pendingProjectSelect: projectobs[0] });
              }
              break;
            case "progress":
              this.setState({
                progressProject: response.data.data,
                dataLoading: false,
              });
              if (this.state.dflag.designation_flag == 4) {
                var projectobs = this.state.progressProject.map(
                  (item) => item.project_id
                );
                this.setState({ progressProjectSelect: projectobs[0] });
              }
              break;
            case "completed":
              this.setState({
                completedProject: response.data.data,
                dataLoading: false,
              });
              if (this.state.dflag.designation_flag == 4) {
                var projectobs = this.state.completedProject.map(
                  (item) => item.project_id
                );
                this.setState({ completedProjectSelect: projectobs[0] });
              }
              break;
            default:
              break;
          }
        }
      })
      .catch((error) => {
        throw error;
      });
  };

  pendingResetState = () => {
    this.setState({
      ...nmContent.listPageResetState.pending,
    });
  };

  progressResetState = () => {
    this.setState({
      ...nmContent.listPageResetState.progress,
    });
  };

  completedResetState = () => {
    this.setState({
      ...nmContent.listPageResetState.completed,
    });
  };

  resetState() {
    this.setState({
      extremeSelect: 0,
      highSelect: 0,
      mediumSelect: 0,
      lowSelect: 0,
      startDate: null,
      endDate: null,
      serviceSelect: null,
      projectSelect: null,
      categorySelect: null,
      personSelect: null,
      overdue: 0,
      all: 0,
    });
  }

  pendingSelectSeverity(e) {
    const severity = this.state.pendingSeverity;
    let index;

    if (e.target.checked) {
      severity.push(+e.target.value);
    } else {
      index = severity.indexOf(+e.target.value);
      severity.splice(index, 1);
    }
    this.setState({ pendingSeverity: severity });
  }

  progressSelectSeverity(e) {
    const severity = this.state.progressSeverity;
    let index;

    if (e.target.checked) {
      severity.push(+e.target.value);
    } else {
      index = severity.indexOf(+e.target.value);
      severity.splice(index, 1);
    }
    this.setState({ progressSeverity: severity });
  }

  completedSelectSeverity(e) {
    const severity = this.state.completedSeverity;
    let index;

    if (e.target.checked) {
      severity.push(+e.target.value);
    } else {
      index = severity.indexOf(+e.target.value);
      severity.splice(index, 1);
    }
    this.setState({ completedSeverity: severity });
  }

  selectSeverity(e) {
    const severity = this.state.severity;
    let index;

    if (e.target.checked) {
      severity.push(+e.target.value);
    } else {
      index = severity.indexOf(+e.target.value);
      severity.splice(index, 1);
    }
    this.setState({ severity: severity });
  }

  pendingFilterData(param, value) {
    if (value == 4) {
      if (param == 0) {
        this.setState({ pendingExtremeSelect: 4, pendingAll: 0 });
      } else {
        this.setState({ pendingExtremeSelect: 0, pendingAll: 0 });
      }
    }
    if (value == 3) {
      if (param == 0) {
        this.setState({ pendingHighSelect: 3, pendingAll: 0 });
      } else {
        this.setState({ pendingHighSelect: 0, pendingAll: 0 });
      }
    }
    if (value == 2) {
      if (param == 0) {
        this.setState({ pendingMediumSelect: 2, pendingAll: 0 });
      } else {
        this.setState({ pendingMediumSelect: 0, pendingAll: 0 });
      }
    }
    if (value == 1) {
      if (param == 0) {
        this.setState({ pendingLowSelect: 1, pendingAll: 0 });
      } else {
        this.setState({ pendingLowSelect: 0, pendingAll: 0 });
      }
    }
    if (value == "overdue") {
      if (param == 0) {
        this.setState({ overdue: 1, all: 0 });
      } else {
        this.setState({ overdue: 0, all: 0 });
      }
    }

    if (value == "all") {
      if (param == 0) {
        this.setState({
          pendingAll: 1,
          pendingExtremeSelect: 4,
          pendingHighSelect: 3,
          pendingMediumSelect: 2,
          pendingLowSelect: 1,
          pendingSeverity: [1, 2, 3, 4],
        });
      } else {
        this.setState({
          pendingAll: 0,
          pendingExtremeSelect: 0,
          pendingHighSelect: 0,
          pendingMediumSelect: 0,
          pendingLowSelect: 0,
          pendingSeverity: [],
        });
      }
    }
  }

  progressFilterData(param, value) {
    if (value == 4) {
      if (param == 0) {
        this.setState({ progressExtremeSelect: 4, progressAll: 0 });
      } else {
        this.setState({ progressExtremeSelect: 0, progressAll: 0 });
      }
    }
    if (value == 3) {
      if (param == 0) {
        this.setState({ progressHighSelect: 3, progressAll: 0 });
      } else {
        this.setState({ progressHighSelect: 0, progressAll: 0 });
      }
    }
    if (value == 2) {
      if (param == 0) {
        this.setState({ progressMediumSelect: 2, progressAll: 0 });
      } else {
        this.setState({ progressMediumSelect: 0, progressAll: 0 });
      }
    }
    if (value == 1) {
      if (param == 0) {
        this.setState({ progressLowSelect: 1, progressAll: 0 });
      } else {
        this.setState({ progressLowSelect: 0, progressAll: 0 });
      }
    }
    if (value == "overdue") {
      if (param == 0) {
        this.setState({ overdue: 1, all: 0 });
      } else {
        this.setState({ overdue: 0, all: 0 });
      }
    }

    if (value == "all") {
      if (param == 0) {
        this.setState({
          progressAll: 1,
          progressExtremeSelect: 4,
          progressHighSelect: 3,
          progressMediumSelect: 2,
          progressLowSelect: 1,
          progressSeverity: [1, 2, 3, 4],
        });
      } else {
        this.setState({
          progressAll: 0,
          progressExtremeSelect: 0,
          progressHighSelect: 0,
          progressMediumSelect: 0,
          progressLowSelect: 0,
          progressSeverity: [],
        });
      }
    }
  }

  completedFilterData(param, value) {
    if (value == 4) {
      if (param == 0) {
        this.setState({ completedExtremeSelect: 4, completedAll: 0 });
      } else {
        this.setState({ completedExtremeSelect: 0, completedAll: 0 });
      }
    }
    if (value == 3) {
      if (param == 0) {
        this.setState({ completedHighSelect: 3, completedAll: 0 });
      } else {
        this.setState({ completedHighSelect: 0, completedAll: 0 });
      }
    }
    if (value == 2) {
      if (param == 0) {
        this.setState({ completedMediumSelect: 2, completedAll: 0 });
      } else {
        this.setState({ completedMediumSelect: 0, completedAll: 0 });
      }
    }
    if (value == 1) {
      if (param == 0) {
        this.setState({ completedLowSelect: 1, completedAll: 0 });
      } else {
        this.setState({ completedLowSelect: 0, completedAll: 0 });
      }
    }
    if (value == "deviation") {
      if (param == 0) {
        this.setState({ deviation: 1, all: 0 });
      } else {
        this.setState({ deviation: 0, all: 0 });
      }
    }

    if (value == "all") {
      if (param == 0) {
        this.setState({
          completedAll: 1,
          completedExtremeSelect: 4,
          completedHighSelect: 3,
          completedMediumSelect: 2,
          completedLowSelect: 1,
          completedSeverity: [1, 2, 3, 4],
        });
      } else {
        this.setState({
          completedAll: 0,
          completedExtremeSelect: 0,
          completedHighSelect: 0,
          completedMediumSelect: 0,
          completedLowSelect: 0,
          completedSeverity: [],
        });
      }
    }
  }

  FilterData(param, value) {
    if (value == 4) {
      if (param == 0) {
        this.setState({ extremeSelect: 4, all: 0 });
      } else {
        this.setState({ extremeSelect: 0, all: 0 });
      }
    }
    if (value == 3) {
      if (param == 0) {
        this.setState({ highSelect: 3, all: 0 });
      } else {
        this.setState({ highSelect: 0, all: 0 });
      }
    }
    if (value == 2) {
      if (param == 0) {
        this.setState({ mediumSelect: 2, all: 0 });
      } else {
        this.setState({ mediumSelect: 0, all: 0 });
      }
    }
    if (value == 1) {
      if (param == 0) {
        this.setState({ lowSelect: 1, all: 0 });
      } else {
        this.setState({ lowSelect: 0, all: 0 });
      }
    }
    if (value == "overdue") {
      if (param == 0) {
        this.setState({ overdue: 1, all: 0 });
      } else {
        this.setState({ overdue: 0, all: 0 });
      }
    }

    if (value == "all") {
      if (param == 0) {
        this.setState({
          all: 1,
          extremeSelect: 4,
          highSelect: 3,
          mediumSelect: 2,
          lowSelect: 1,
          severity: [1, 2, 3, 4],
        });
      } else {
        this.setState({
          all: 0,
          extremeSelect: 0,
          highSelect: 0,
          mediumSelect: 0,
          lowSelect: 0,
          severity: [],
        });
      }
    }
  }

  _handlePendingServiceChange = async (event) => {
    const selectedServiceID = event ? event.target.value : "";
    await this.setState({ pendingServiceSelect: selectedServiceID, pendingProjectSelect: "" });
    if (selectedServiceID) {
      this._getProject("pending", selectedServiceID);
    }
  };

  _handleProgressServiceChange = async (event) => {
    const selectedServiceID = event ? event.target.value : "";
    await this.setState({ inProgressServiceSelect: selectedServiceID, progressProjectSelect: "" });
    if (selectedServiceID) {
      this._getProject("progress", selectedServiceID);
    }
  };

  _handleCompletedServiceChange = async (event) => {
    const selectedServiceID = event ? event.target.value : "";
    await this.setState({ completedServiceSelect: selectedServiceID, completedProjectSelect: "" });
    if (selectedServiceID) {
      this._getProject("completed", selectedServiceID);
    }
  };

  _handleServiceChange = async (event) => {
    const selectedServiceID = event.target.value;
    if (selectedServiceID) {
      await this.setState({ serviceSelect: selectedServiceID });
      this._getProject();
    }
  };

  _handlePendingFilter = () => {
    try {
      let { ...data } = this.state;
      const start_date = data.pendingStartDate
        ? moment(data.pendingStartDate).format("YYYY-MM-DD")
        : "";
      const end_date = data.pendingEndDate
        ? moment(data.pendingEndDate).format("YYYY-MM-DD")
        : "";

      this.props.nmPendingListFilter(
        data.pendingSeverity,
        start_date,
        end_date,
        data.pendingServiceSelect,
        data.pendingProjectSelect,
        data.pendingFilterPageNo,
        data.pendingCompanySelect,
        data.pendingCategorySelect
      );
      this.pendingModal(false);

      this.setState({
        pendingFilterFlag: 1,
      });
    } catch (error) { }
  };

  _pendingFilterPagination = () => {
    try {
      let { ...data } = this.state;
      const start_date = data.pendingStartDate
        ? moment(data.pendingStartDate).format("YYYY-MM-DD")
        : "";
      const end_date = data.pendingEndDate
        ? moment(data.pendingEndDate).format("YYYY-MM-DD")
        : "";

      this.props.nmPendingListFilter(
        data.pendingSeverity,
        start_date,
        end_date,
        data.pendingServiceSelect,
        data.pendingProjectSelect,
        data.pendingFilterPageNo,
        data.pendingCompanySelect,
        data.pendingCategorySelect
      );
      this.pendingModal(false);

      this.setState({
        pendingFilterFlag: 1,
      });
    } catch (error) { }
  };

  _handlePendingScrollbarPagination = () => {
    if (this.state.pendingFilterFlag == 1) {
      if (this.props.pendingFilterCount != this.props.nmPending.length) {
        // this._handlePendingFilter();
        this._pendingFilterPagination();
      }
    } else {
      if (this.props.nmPending.length != this.props.nmPendingCount) {
        this.props._getNMList(this.props.nmPendingPageNo + 1);
      }
    }
  };

  _handleInprogressScrollbarPagination = () => {
    if (this.state.inprogressFilterFlag == 1) {
      if (this.props.inprogressFilterCount != this.props.nmProgress.length) {
        // this._handlePendingFilter();
        this._inProgressFilterPagination();
      }
    } else {
      if (this.props.nmProgress.length != this.props.nmProgressCount) {
        this.props._getNMProgressList(this.props.nmProgressPageNo + 1);
      }
    }
  };

  _inProgressFilterPagination = () => {
    try {
      let { ...data } = this.state;
      const start_date = data.progressStartDate
        ? moment(data.progressStartDate).format("YYYY-MM-DD")
        : "";
      const end_date = data.progressEndDate
        ? moment(data.progressEndDate).format("YYYY-MM-DD")
        : "";

      this.props.nmProgressListFilter(
        data.progressSeverity,
        start_date,
        end_date,
        data.inProgressServiceSelect,
        data.progressProjectSelect,
        data.overdue,
        data.inprogressFilterPageNo,
        data.inProgressCompanySelect,
        data.inProgressCategorySelect
      );
      this.inProgressModal(false);

      this.setState({
        inprogressFilterFlag: 1,
      });
    } catch (error) { }
  };

  _handleInProgressFilter = () => {
    try {
      let { ...data } = this.state;
      const start_date = data.progressStartDate
        ? moment(data.progressStartDate).format("YYYY-MM-DD")
        : "";
      const end_date = data.progressEndDate
        ? moment(data.progressEndDate).format("YYYY-MM-DD")
        : "";

      this.props.nmProgressListFilter(
        data.progressSeverity,
        start_date,
        end_date,
        data.inProgressServiceSelect,
        data.progressProjectSelect,
        data.overdue,
        data.inprogressFilterPageNo,
        data.inProgressCompanySelect,
        data.inProgressCategorySelect
      );
      this.inProgressModal(false);

      this.setState({
        inprogressFilterFlag: 1,
      });
    } catch (error) { }
  };

  _handleCompletedFilter = () => {
    try {
      let { ...data } = this.state;
      const start_date = data.completedStartDate
        ? moment(data.completedStartDate).format("YYYY-MM-DD")
        : "";
      const end_date = data.completedEndDate
        ? moment(data.completedEndDate).format("YYYY-MM-DD")
        : "";

      this.props.nmCompletedListFilter(
        data.completedSeverity,
        start_date,
        end_date,
        data.completedServiceSelect,
        data.completedProjectSelect,
        data.deviation,
        data.completedFilterPageNo,
        data.completedCompanySelect,
        data.completedCategorySelect
      );
      this.completedModal(false);
      this.setState({
        completedFilterFlag: 1,
      });
    } catch (error) { }
  };

  _completedPaginationFilter = () => {
    try {
      let { ...data } = this.state;
      const start_date = data.completedStartDate
        ? moment(data.completedStartDate).format("YYYY-MM-DD")
        : "";
      const end_date = data.completedEndDate
        ? moment(data.completedEndDate).format("YYYY-MM-DD")
        : "";

      this.props.nmCompletedListFilter(
        data.completedSeverity,
        start_date,
        end_date,
        data.completedServiceSelect,
        data.completedProjectSelect,
        data.deviation,
        data.completedFilterPageNo,
        data.completedCompanySelect,
        data.completedCategorySelect
      );
      this.completedModal(false);
      this.setState({
        completedFilterFlag: 1,
      });
    } catch (error) { }
  };

  _handleCompleteScrollbarPagination = () => {
    if (this.state.completedFilterFlag == 1) {
      if (this.props.completeFilterCount != this.props.nmCompleted.length) {
        this._completedPaginationFilter();
      }
    } else {
      if (this.props.nmCompleted.length != this.props.nmCompletedCount) {
        this.props._getNMCompletedList(this.props.nmCompletedPageNo + 1);
      }
    }
  };

  _handleFilterReset = async (moduleName = "pending") => {
    switch (moduleName) {
      case "pending":
        this.props.filterReset("pending");
        this.pendingResetState();
        break;
      case "progress":
        this.props.filterReset("progress");
        this.progressResetState();
        break;
      case "completed":
        this.props.filterReset("completed");
        this.completedResetState();
        break;
      default:
        break;
    }

    this.setState({
      pendingFilterFlag: 0,
      completedFilterFlag: 0,
      inprogressFilterFlag: 0,
    });
  };

  pendingResetState = () => {
    this.setState({
      pendingCompanySelect: "",
      pendingServiceSelect: "",
      pendingProjectSelect: "",
      pendingCategorySelect: "",
      pendingStartDate: null,
      pendingEndDate: null,
      pendingSeverity: "",
    }, () => {
      if (this.props._getNMList) this.props._getNMList(1);
    });
  };

  progressResetState = () => {
    this.setState({
      inProgressCompanySelect: "",
      inProgressServiceSelect: "",
      progressProjectSelect: "",
      inProgressCategorySelect: "",
      progressStartDate: null,
      progressEndDate: null,
      progressSeverity: "",
    }, () => {
      if (this.props._getNMProgressList) this.props._getNMProgressList(1);
    });
  };

  completedResetState = () => {
    this.setState({
      completedCompanySelect: "",
      completedServiceSelect: "",
      completedProjectSelect: "",
      completedCategorySelect: "",
      completedStartDate: null,
      completedEndDate: null,
      completedSeverity: "",
    }, () => {
      if (this.props._getNMCompletedList) this.props._getNMCompletedList(1);
    });
  };

  comapareTargetDate = (date = "") => {
    if (date) {
      const targetDate = moment(date, "DD/MM/YYYY");
      const today = moment();
      if (targetDate.isSame(today, "day")) {
        return true;
      }
      return false;
    }
  };

  _handleLightBox = async (list) => {
    await this.setState({
      lightboxactive: true,
      fsToggler: !this.state.fsToggler,
      evidencelightbox: list.map((item) => item.link),
      evidencelightboxType: list.map((item) =>
        item.format == "img" ? "image" : item.format?.split("/")[0]
      ),
    });
  };

  __toggleGridView = (tabName) => {
    if (this.state.listMode !== tabName) {
      this.setState({ listMode: tabName });
    }
  };

  _setDataLoading = (state) => {
    this.setState({
      dataLoading: state,
    })
  }

  __generateTableBody = (data, idx, customColumns = [], status = "pending") => {
    return (
      <tr key={idx}>
        <td>
          {" "}
          <Link to={`/nm-detail/${data.nearmiss_id}/kanban/${status}`} className="text-decoration-none clide-v2-secondary-color"
          >
            {data.type_of_act || ""}{" "}
          </Link>
        </td>
        <td>{data.activity}</td>
        <td>
          {data.evidence.length ? (
            <>
              {data.evidence[0]?.format === "video" ? (
                <img
                  src={require("assets/sls-icons/V2. New Development/Video Player (1).svg")}
                  className="cursor-pointer svg-icons "
                  onClick={() =>
                    this.setState({ videoUrl: data.evidence[0]?.link })
                  }
                />
              ) : (
                <div>
                  <img
                    className="clide-v2-profile-img cursor-pointer rounded"
                    src={data.evidence[0]?.link}
                    title={this.props.t('evidence')}
                    onClick={() => this._handleLightBox(data.evidence)}
                  />
                </div>
              )}
            </>
          ) : (
            <div>
              <img
                className="clide-v2-profile-img "
                src={require("assets/images/icons/fimage.svg")}
                title={this.props.t('evidence')}
              />
            </div>
          )}
        </td>
        <td>{data.service}</td>
        <td>{data.project}</td>
        <td>
          <img src={data.reported_by_pic} className="clide-v2-profile-img " />
          {data.reported_by}
        </td>
        <td>{data.report_date}</td>
        {customColumns.length ? (
          <>
            {customColumns.includes(this.props.t('dueDate')) ? (
              <td>
                <div
                  style={{
                    border: `1px solid #faac15`,
                    borderRadius: "28px",
                    color: "#faac15",
                    width: "max-content",
                  }}
                  className="px-3 py-1 my-2 font-weight-500 "
                >
                  {data.target_date || "NA"}
                </div>
              </td>
            ) : null}
            {customColumns.includes(this.props.t('closedOn')) ? (
              <td>
                <div
                  style={{
                    border: `1px solid #faac15`,
                    borderRadius: "28px",
                    color: "#faac15",
                    width: "max-content",
                  }}
                  className="px-3 py-1 my-2 font-weight-500 "
                >
                  {data.closing_date || "NA"}
                </div>
              </td>
            ) : null}
            <td>
              {data.team != undefined &&
                data.team.map((team, index) => (
                  <div key={index}>
                    {team.status == 1 && (
                      <div className="people-lead border-0 d-flex align-items-center">
                        <img
                          src={team.pic}
                          className="clide-v2-profile-img"
                          title={team.name}
                          alt="team"
                        />
                        <div>
                          <span className="font-16 font-weight-500">
                            {team.name}
                          </span>
                        </div>
                      </div>
                    )}
                  </div>
                ))}
            </td>
            <td>
              <div
                style={{
                  border: `1px solid #FF0000`,
                  borderRadius: "28px",
                  color: "#FF0000",
                  width: "max-content",
                }}
                className="px-3 py-1 my-2 font-weight-500 "
              >
                {customColumns.includes("Overdue")
                  ? data.overdue_days || data.overdue
                  : data.overdue_days || data.overdue || "NA"}
              </div>
            </td>
          </>
        ) : null}
      </tr>
    );
  };
  getFieldProps = (data, customColumns = [], status) => {
    const {t} = this.props;
    return {
      data,
      columns: [
        t('act'),
        t('activity'),
        t('evidence'),
        t('service'),
        t('plantProject'),
        t('reportedBy'),
        t('reportedOn'),
        ...customColumns,
      ],
      bodyRendrer: (data, idx) =>
        this.__generateTableBody(data, idx, customColumns, status),
    };
  };
  debounceFunc = _.debounce(function (callback) {
    callback();
  }, 300);
  render() {
    const { dataLoading } = this.state;
    const {t} = this.props;

    if (dataLoading) {
      return <ClideLoader />;
    }
    return (
      <>
        <div className="row  clide-v2-colume_title">
          <div class="col-12 col-md-5">
            <div className="clide-v2-white-box mb-3">
              <div className="input-group">
                <input
                  type="text"
                  className="form-control"
                  placeholder={t('searchByCategory')}
                  aria-label="Search"
                  aria-describedby="button-addon2"
                  value={this.props.state.searchList2}
                  onChange={(e) => this.props.handleInputChange(e)}
                />
                <button
                  className="btn btn-secondary clide-v2-bg-white clide-v2-border-color border-start-0"
                  type="button"
                  id="button-addon2"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width={20}
                    height={20}
                    fill="none"
                    viewBox="0 0 20 20"
                  >
                    <path
                      fill="#F56620"
                      d="M8.333 3.334a5 5 0 100 10 5 5 0 000-10zm-6.666 5A6.667 6.667 0 1113.6 12.422l4.49 4.49a.833.833 0 01-1.18 1.178l-4.488-4.49A6.667 6.667 0 011.667 8.334z"
                    ></path>
                  </svg>
                </button>
              </div>
            </div>
          </div>
          <div class="col-6 col-md-5"></div>
          <div class="col-12 col-md-2 mb-2">
            <div class="d-flex justify-content-end">
              <button className="border-0 bg-transparent" title={t('listView')} onClick={() => this.__toggleGridView("list")}>
                <KanbanListTypeIcon />
              </button>
              <button className="border-0 bg-transparent" title={t('kanbanView')} onClick={() => this.__toggleGridView("kanban")}>
                <KanbanGridIcon />
              </button>


              <div>
                <div>{nmContent(t).excelExportNmlist(this.props.state, this._setDataLoading)}</div>
              </div>
            </div>

          </div>

          <ListPendingSection
            state={this.state}
            functionContent={this}
            props={this.props}
          />
          <ListInprogressSection
            state={this.state}
            functionContent={this}
            props={this.props}
          />
          <ListCompletedSection
            state={this.state}
            functionContent={this}
            props={this.props}
          />
        </div>
        <Modal
          centered
          show={this.state.pendingPopup}
          onHide={() => this.pendingModal(false)}
          size="lg"
        >
          <Modal.Header className="align-items-center border-bottom px-4 py-3 bg-white">
            <div className="d-flex align-items-center justify-content-between w-100">
              <span className="font-18 font-weight-700 text-dark">{t('pendingFilter')}</span>
              <div className="d-flex align-items-center">
                <button
                  type="button"
                  className="btn btn-sm btn-light border font-weight-600 px-3 py-1 mr-2 rounded-pill"
                  onClick={() => this._handleFilterReset("pending")}
                >
                  {t('reset')}
                </button>
                <button
                  type="button"
                  className="btn btn-sm btn-primary font-weight-600 px-4 py-1 mr-3 rounded-pill shadow-sm"
                  style={{ backgroundColor: "#f97316", borderColor: "#f97316" }}
                  onClick={() =>
                    this.debounceFunc(() => {
                      this._handlePendingFilter();
                    })
                  }
                >
                  {t('apply')}
                </button>
                <X
                  style={{ height: "20px", width: "20px", cursor: "pointer", color: "#64748b" }}
                  onClick={() =>
                    this.setState({
                      pendingPopup: false,
                    })
                  }
                />
              </div>
            </div>
          </Modal.Header>
          <Modal.Body className="p-4">
            <div className="nm-filter-modal-custom">
              <style>{`
                .nm-filter-modal-custom .filter-label {
                  font-weight: 600;
                  font-size: 13.5px;
                  color: #334155;
                  margin-bottom: 6px;
                  display: block;
                }
                .nm-filter-modal-custom .risk-chip-container {
                  display: flex;
                  flex-wrap: wrap;
                  gap: 10px;
                  margin-top: 6px;
                  margin-bottom: 18px;
                }
                .nm-filter-modal-custom label.risk-chip {
                  display: inline-flex !important;
                  align-items: center !important;
                  gap: 8px !important;
                  padding: 7px 16px !important;
                  border-radius: 20px !important;
                  border: 1px solid #cbd5e1 !important;
                  background: #f8fafc !important;
                  font-size: 13px !important;
                  font-weight: 500 !important;
                  color: #475569 !important;
                  cursor: pointer !important;
                  user-select: none !important;
                  transition: all 0.2s ease !important;
                  margin-bottom: 0 !important;
                  margin-top: 0 !important;
                }
                .nm-filter-modal-custom label.risk-chip:hover {
                  background: #fff7ed !important;
                  border-color: #fdba74 !important;
                }
                .nm-filter-modal-custom label.risk-chip.active {
                  background: #fff7ed !important;
                  border-color: #f97316 !important;
                  color: #ea580c !important;
                  font-weight: 600 !important;
                  box-shadow: 0 1px 3px rgba(249, 115, 22, 0.2) !important;
                }
                .nm-filter-modal-custom .risk-dot {
                  width: 9px !important;
                  height: 9px !important;
                  border-radius: 50% !important;
                  display: inline-block !important;
                  flex-shrink: 0 !important;
                  margin-right: 8px !important;
                }
                .risk-dot.all { background: #64748b; }
                .risk-dot.extreme { background: #ef4444; }
                .risk-dot.high { background: #f97316; }
                .risk-dot.medium { background: #eab308; }
                .risk-dot.low { background: #22c55e; }
                .nm-filter-modal-custom label:not(.risk-chip),
                .nm-filter-modal-custom .filter-label,
                .nm-filter-modal-custom .slds-form-element__label {
                  font-size: 13.5px !important;
                  font-weight: 600 !important;
                  color: #1e293b !important;
                  margin-bottom: 6px !important;
                  margin-top: 0 !important;
                  display: block !important;
                  letter-spacing: 0.2px;
                }
                .nm-filter-modal-custom select,
                .nm-filter-modal-custom select.form-control,
                .nm-filter-modal-custom select.slds-select,
                .nm-filter-modal-custom .form-control,
                .nm-filter-modal-custom .slds-select,
                .nm-filter-modal-custom .calender-div input {
                  height: 42px !important;
                  min-height: 42px !important;
                  max-height: 42px !important;
                  line-height: 40px !important;
                  border-radius: 8px !important;
                  border: 1px solid #cbd5e1 !important;
                  font-size: 13.5px !important;
                  color: #334155 !important;
                  background-color: #ffffff !important;
                  padding: 0 14px !important;
                  box-sizing: border-box !important;
                  width: 100% !important;
                }
                .nm-filter-modal-custom select,
                .nm-filter-modal-custom select.form-control,
                .nm-filter-modal-custom select.slds-select {
                  padding-right: 32px !important;
                  background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3e%3cpath fill='none' stroke='%2364748b' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='M2 5l6 6 6-6'/%3e%3c/svg%3e") !important;
                  background-repeat: no-repeat !important;
                  background-position: right 12px center !important;
                  background-size: 12px 12px !important;
                  appearance: none !important;
                  -webkit-appearance: none !important;
                  -moz-appearance: none !important;
                }
                .nm-filter-modal-custom select.form-control:focus,
                .nm-filter-modal-custom select.slds-select:focus,
                .nm-filter-modal-custom .form-control:focus,
                .nm-filter-modal-custom .slds-select:focus,
                .nm-filter-modal-custom .calender-div input:focus {
                  border-color: #3b82f6 !important;
                  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.12) !important;
                }
                .nm-filter-modal-custom .calender-div {
                  position: relative;
                }
                .nm-filter-modal-custom .calender-div input {
                  padding-left: 38px !important;
                }
                .nm-filter-modal-custom .calender-icon {
                  position: absolute;
                  left: 12px;
                  top: 50%;
                  transform: translateY(-50%);
                  color: #64748b;
                  width: 16px;
                  height: 16px;
                }
                .nm-filter-modal-custom .slds-form-element,
                .nm-filter-modal-custom .form-group {
                  margin-bottom: 0 !important;
                }
              `}</style>


              {/* Risk Level - Single Select */}
              <div className="form-group mb-4">
                <label className="filter-label">{t('riskLevel')}</label>
                <div className="risk-chip-container">
                  {[
                    { label: 'Critical', value: 4, dot: 'extreme' },
                    { label: t('high'), value: 3, dot: 'high' },
                    { label: t('medium'), value: 2, dot: 'medium' },
                    { label: t('low'), value: 1, dot: 'low' },
                  ].map(({ label, value, dot }) => (
                    <label
                      key={value}
                      className={`risk-chip ${this.state.pendingSeverity === value ? 'active' : ''}`}
                      onClick={() => this.setState({ pendingSeverity: this.state.pendingSeverity === value ? '' : value })}
                      style={{ cursor: 'pointer' }}
                    >
                      <span className={`risk-dot ${dot}`}></span>
                      <span>{label}</span>
                    </label>
                  ))}
                </div>
              </div>


              {/* Company, Service, Project Category, Plant/Project/Client */}
              <div className="form-group mb-3">
                <Row>
                  {this.state.orgSettings?.company && (
                    <Col sm={6} className="mb-3">
                      <CompanyList
                        optionList={(this.state.companyList || []).map((item) => ({
                          companyId: item.id || item.company_id || item.companyId,
                          companyName: item.company_name || item.name || item.companyName,
                        }))}
                        onChangeHandle={(val) => {
                          this.setState({ pendingCompanySelect: val, pendingServiceSelect: "", pendingProjectSelect: "" });
                          this._fetchServiceForSection(val, "pending");
                        }}
                        value={this.state.pendingCompanySelect}
                        isRquired={false}
                        titleview={true}
                      />
                    </Col>
                  )}
                  <Col sm={6} className="mb-3">
                    <label className="filter-label">Service</label>
                    <select
                      className="form-control"
                      value={this.state.pendingServiceSelect}
                      onChange={this._handlePendingServiceChange}
                    >
                      <option value="">Select Service</option>
                      {this.state.pendingService.map((service, index) => (
                        <option key={index} value={service.service_id}>
                          {service.service_name}
                        </option>
                      ))}
                    </select>
                  </Col>
                  {this.state.orgSettings?.category && (
                    <Col sm={6} className="mb-3">
                      <CommonDropdown
                        title={"Project Category"}
                        customPlaceHolder={"Project Category"}
                        optionList={(() => {
                          const list = this.state.categoryList || [];
                          let filtered = list;
                          if (this.state.pendingServiceSelect) {
                            const selectedService = (this.state.pendingService || []).find(
                              (s) => String(s.streamId || s.serviceId || s.service_id || s.id) === String(this.state.pendingServiceSelect)
                            );
                            const selectedServiceName = selectedService
                              ? (selectedService.streamName || selectedService.serviceName || selectedService.service_name || selectedService.name)
                              : "";
                            filtered = list.filter((c) => {
                              const cServiceId = c.stream_id || c.service_id || c.serviceId || c.streamId || c.service?.id || c.service?.streamId || c.service?.serviceId;
                              const matchId = cServiceId && String(cServiceId) === String(this.state.pendingServiceSelect);
                              const cServiceName = c.service_name || c.serviceName || c.streamName || c.service?.service_name || c.service?.name;
                              const matchName = selectedServiceName && cServiceName && String(cServiceName).toLowerCase() === String(selectedServiceName).toLowerCase();
                              return matchId || matchName;
                            });
                          }
                          const source = filtered.length > 0 ? filtered : list;
                          const uniqueMap = new Map();
                          source.forEach((item) => {
                            const id = item.id || item.sub_vertical_id || item.project_category_id;
                            const name = item.name || item.sub_vertical_name || item.project_category_name || item.title;
                            if (id && name && !uniqueMap.has(id)) {
                              uniqueMap.set(id, { id, name });
                            }
                          });
                          return Array.from(uniqueMap.values());
                        })()}
                        onChangeHandle={(e) => {
                          const val = e && e.target ? e.target.value : e;
                          this.setState({ pendingCategorySelect: val });
                        }}
                        isRequired={false}
                        titleview={true}
                        value={this.state.pendingCategorySelect}
                      />
                    </Col>
                  )}
                  <Col sm={6} className="mb-3">
                    <label className="filter-label">Plant / Project / Client</label>
                    <select
                      className="form-control"
                      value={this.state.pendingProjectSelect}
                      onChange={(e) => {
                        this.setState({ pendingProjectSelect: e.target.value });
                      }}
                    >
                      <option value="">Select Plant / Project / Client</option>
                      {this.state.pendingProject.map((project, index) => (
                        <option key={index} value={project.project_id}>
                          {project.project}
                        </option>
                      ))}
                    </select>
                  </Col>
                </Row>
              </div>

              {/* Date Range */}
              <div className="form-group mb-2">
                <label className="filter-label">By Report Date</label>
                <Row className="align-items-center">
                  <Col sm={5}>
                    <div className="calender-div">
                      <DatePicker
                        selected={this.state.pendingStartDate}
                        onChange={(jsDate) =>
                          this.setState({ pendingStartDate: jsDate })
                        }
                        placeholderText={t('selectStartDate')}
                        maxDate={new Date()}
                        portalId="root"
                      />
                      <Calendar className="calender-icon" />
                    </div>
                  </Col>
                  <Col sm={2} className="text-center font-weight-600 text-muted">
                    {t('to')}
                  </Col>
                  <Col sm={5}>
                    <div className="calender-div">
                      <DatePicker
                        selected={this.state.pendingEndDate}
                        onChange={(jsDate) =>
                          this.setState({ pendingEndDate: jsDate })
                        }
                        placeholderText={t('selectEndDate')}
                        minDate={this.state.pendingStartDate}
                      />
                      <Calendar className="calender-icon" />
                    </div>
                  </Col>
                </Row>
              </div>
            </div>
          </Modal.Body>
        </Modal>

        {/* In progress filter popup */}
        <Modal
          centered
          show={this.state.inProgressPopup}
          onHide={() => this.inProgressModal(false)}
          size="lg"
        >
          <Modal.Header className="align-items-center border-bottom px-4 py-3 bg-white">
            <div className="d-flex align-items-center justify-content-between w-100">
              <span className="font-18 font-weight-700 text-dark">{t('inProgressFilter')}</span>
              <div className="d-flex align-items-center">
                <button
                  type="button"
                  className="btn btn-sm btn-light border font-weight-600 px-3 py-1 mr-2 rounded-pill"
                  onClick={() => this._handleFilterReset("progress")}
                >
                  {t('reset')}
                </button>
                <button
                  type="button"
                  className="btn btn-sm btn-primary font-weight-600 px-4 py-1 mr-3 rounded-pill shadow-sm"
                  style={{ backgroundColor: "#f97316", borderColor: "#f97316" }}
                  onClick={() =>
                    this.debounceFunc(() => {
                      this._handleInProgressFilter();
                    })
                  }
                >
                  {t('apply')}
                </button>
                <X
                  style={{ height: "20px", width: "20px", cursor: "pointer", color: "#64748b" }}
                  onClick={() =>
                    this.setState({
                      inProgressPopup: false,
                    })
                  }
                />
              </div>
            </div>
          </Modal.Header>

          <Modal.Body className="p-4">
            <div className="nm-filter-modal-custom">
              <style>{`
                .nm-filter-modal-custom .filter-label {
                  font-weight: 600;
                  font-size: 13.5px;
                  color: #334155;
                  margin-bottom: 6px;
                  display: block;
                }
                .nm-filter-modal-custom .risk-chip-container {
                  display: flex;
                  flex-wrap: wrap;
                  gap: 10px;
                  margin-top: 6px;
                  margin-bottom: 18px;
                }
                .nm-filter-modal-custom label.risk-chip {
                  display: inline-flex !important;
                  align-items: center !important;
                  gap: 8px !important;
                  padding: 7px 16px !important;
                  border-radius: 20px !important;
                  border: 1px solid #cbd5e1 !important;
                  background: #f8fafc !important;
                  font-size: 13px !important;
                  font-weight: 500 !important;
                  color: #475569 !important;
                  cursor: pointer !important;
                  user-select: none !important;
                  transition: all 0.2s ease !important;
                  margin-bottom: 0 !important;
                  margin-top: 0 !important;
                }
                .nm-filter-modal-custom label.risk-chip:hover {
                  background: #fff7ed !important;
                  border-color: #fdba74 !important;
                }
                .nm-filter-modal-custom label.risk-chip.active {
                  background: #fff7ed !important;
                  border-color: #f97316 !important;
                  color: #ea580c !important;
                  font-weight: 600 !important;
                  box-shadow: 0 1px 3px rgba(249, 115, 22, 0.2) !important;
                }
                .nm-filter-modal-custom .risk-dot {
                  width: 9px !important;
                  height: 9px !important;
                  border-radius: 50% !important;
                  display: inline-block !important;
                  flex-shrink: 0 !important;
                  margin-right: 8px !important;
                }
                .risk-dot.all { background: #64748b; }
                .risk-dot.extreme { background: #ef4444; }
                .risk-dot.high { background: #f97316; }
                .risk-dot.medium { background: #eab308; }
                .risk-dot.low { background: #22c55e; }
                .nm-filter-modal-custom label:not(.risk-chip),
                .nm-filter-modal-custom .filter-label,
                .nm-filter-modal-custom .slds-form-element__label {
                  font-size: 13.5px !important;
                  font-weight: 600 !important;
                  color: #1e293b !important;
                  margin-bottom: 6px !important;
                  margin-top: 0 !important;
                  display: block !important;
                  letter-spacing: 0.2px;
                }
                .nm-filter-modal-custom select,
                .nm-filter-modal-custom select.form-control,
                .nm-filter-modal-custom select.slds-select,
                .nm-filter-modal-custom .form-control,
                .nm-filter-modal-custom .slds-select,
                .nm-filter-modal-custom .calender-div input {
                  height: 42px !important;
                  min-height: 42px !important;
                  max-height: 42px !important;
                  line-height: 40px !important;
                  border-radius: 8px !important;
                  border: 1px solid #cbd5e1 !important;
                  font-size: 13.5px !important;
                  color: #334155 !important;
                  background-color: #ffffff !important;
                  padding: 0 14px !important;
                  box-sizing: border-box !important;
                  width: 100% !important;
                }
                .nm-filter-modal-custom select,
                .nm-filter-modal-custom select.form-control,
                .nm-filter-modal-custom select.slds-select {
                  padding-right: 32px !important;
                  background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3e%3cpath fill='none' stroke='%2364748b' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='M2 5l6 6 6-6'/%3e%3c/svg%3e") !important;
                  background-repeat: no-repeat !important;
                  background-position: right 12px center !important;
                  background-size: 12px 12px !important;
                  appearance: none !important;
                  -webkit-appearance: none !important;
                  -moz-appearance: none !important;
                }
                .nm-filter-modal-custom select.form-control:focus,
                .nm-filter-modal-custom select.slds-select:focus,
                .nm-filter-modal-custom .form-control:focus,
                .nm-filter-modal-custom .slds-select:focus,
                .nm-filter-modal-custom .calender-div input:focus {
                  border-color: #3b82f6 !important;
                  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.12) !important;
                }
                .nm-filter-modal-custom .calender-div {
                  position: relative;
                }
                .nm-filter-modal-custom .calender-div input {
                  padding-left: 14px !important;
                  padding-right: 38px !important;
                }
                .nm-filter-modal-custom .calender-icon {
                  position: absolute;
                  right: 12px !important;
                  left: auto !important;
                  top: 50%;
                  transform: translateY(-50%);
                  color: #64748b;
                  width: 16px;
                  height: 16px;
                  pointer-events: none;
                }
                .nm-filter-modal-custom .slds-form-element,
                .nm-filter-modal-custom .form-group {
                  margin-bottom: 0 !important;
                }
              `}</style>


              {/* Risk Level - Single Select */}
              <div className="form-group mb-4">
                <label className="filter-label">{t('riskLevel')}</label>
                <div className="risk-chip-container">
                  {[
                    { label: 'Critical', value: 4, dot: 'extreme' },
                    { label: t('high'), value: 3, dot: 'high' },
                    { label: t('medium'), value: 2, dot: 'medium' },
                    { label: t('low'), value: 1, dot: 'low' },
                  ].map(({ label, value, dot }) => (
                    <label
                      key={value}
                      className={`risk-chip ${this.state.progressSeverity === value ? 'active' : ''}`}
                      onClick={() => this.setState({ progressSeverity: this.state.progressSeverity === value ? '' : value })}
                      style={{ cursor: 'pointer' }}
                    >
                      <span className={`risk-dot ${dot}`}></span>
                      <span>{label}</span>
                    </label>
                  ))}
                </div>
              </div>


              {/* Company, Service, Project Category, Plant/Project/Client */}
              <div className="form-group mb-3">
                <Row>
                  {this.state.orgSettings?.company && (
                    <Col sm={6} className="mb-3">
                      <CompanyList
                        optionList={(this.state.companyList || []).map((item) => ({
                          companyId: item.id || item.company_id || item.companyId,
                          companyName: item.company_name || item.name || item.companyName,
                        }))}
                        onChangeHandle={(val) => {
                          this.setState({ inProgressCompanySelect: val, inProgressServiceSelect: "", progressProjectSelect: "" });
                          this._fetchServiceForSection(val, "progress");
                        }}
                        value={this.state.inProgressCompanySelect}
                        isRquired={false}
                        titleview={true}
                      />
                    </Col>
                  )}
                  <Col sm={6} className="mb-3">
                    <label className="filter-label">Service</label>
                    <select
                      className="form-control"
                      value={this.state.inProgressServiceSelect}
                      onChange={this._handleProgressServiceChange}
                    >
                      <option value="">Select Service</option>
                      {this.state.inProgressService.map((service, index) => (
                        <option key={index} value={service.service_id}>
                          {service.service_name}
                        </option>
                      ))}
                    </select>
                  </Col>
                  {this.state.orgSettings?.category && (
                    <Col sm={6} className="mb-3">
                      <CommonDropdown
                        title={"Project Category"}
                        customPlaceHolder={"Project Category"}
                        optionList={(() => {
                          const list = this.state.categoryList || [];
                          let filtered = list;
                          if (this.state.inProgressServiceSelect) {
                            const selectedService = (this.state.inProgressService || []).find(
                              (s) => String(s.streamId || s.serviceId || s.service_id || s.id) === String(this.state.inProgressServiceSelect)
                            );
                            const selectedServiceName = selectedService
                              ? (selectedService.streamName || selectedService.serviceName || selectedService.service_name || selectedService.name)
                              : "";
                            filtered = list.filter((c) => {
                              const cServiceId = c.stream_id || c.service_id || c.serviceId || c.streamId || c.service?.id || c.service?.streamId || c.service?.serviceId;
                              const matchId = cServiceId && String(cServiceId) === String(this.state.inProgressServiceSelect);
                              const cServiceName = c.service_name || c.serviceName || c.streamName || c.service?.service_name || c.service?.name;
                              const matchName = selectedServiceName && cServiceName && String(cServiceName).toLowerCase() === String(selectedServiceName).toLowerCase();
                              return matchId || matchName;
                            });
                          }
                          const source = filtered.length > 0 ? filtered : list;
                          const uniqueMap = new Map();
                          source.forEach((item) => {
                            const id = item.id || item.sub_vertical_id || item.project_category_id;
                            const name = item.name || item.sub_vertical_name || item.project_category_name || item.title;
                            if (id && name && !uniqueMap.has(id)) {
                              uniqueMap.set(id, { id, name });
                            }
                          });
                          return Array.from(uniqueMap.values());
                        })()}
                        onChangeHandle={(e) => {
                          const val = e && e.target ? e.target.value : e;
                          this.setState({ inProgressCategorySelect: val });
                        }}
                        isRequired={false}
                        titleview={true}
                        value={this.state.inProgressCategorySelect}
                      />
                    </Col>
                  )}
                  <Col sm={6} className="mb-3">
                    <label className="filter-label">Plant / Project / Client</label>
                    <select
                      className="form-control"
                      value={this.state.progressProjectSelect}
                      onChange={(e) => {
                        this.setState({ progressProjectSelect: e.target.value });
                      }}
                    >
                      <option value="">Select Plant / Project / Client</option>
                      {this.state.progressProject.map((project, index) => (
                        <option key={index} value={project.project_id}>
                          {project.project}
                        </option>
                      ))}
                    </select>
                  </Col>
                </Row>
              </div>

              {/* Date Range */}
              <div className="form-group mb-2">
                <label className="filter-label">By Report Date</label>
                <Row className="align-items-center">
                  <Col sm={5}>
                    <div className="calender-div">
                      <DatePicker
                        selected={this.state.progressStartDate}
                        onChange={(jsDate) =>
                          this.setState({ progressStartDate: jsDate })
                        }
                        placeholderText={t('selectStartDate')}
                        maxDate={new Date()}
                      />
                      <Calendar className="calender-icon" />
                    </div>
                  </Col>
                  <Col sm={2} className="text-center font-weight-600 text-muted">
                    {t('to')}
                  </Col>
                  <Col sm={5}>
                    <div className="calender-div">
                      <DatePicker
                        selected={this.state.progressEndDate}
                        onChange={(jsDate) =>
                          this.setState({ progressEndDate: jsDate })
                        }
                        placeholderText={t('selectEndDate')}
                        minDate={this.state.progressStartDate}
                      />
                      <Calendar className="calender-icon" />
                    </div>
                  </Col>
                </Row>
              </div>
            </div>
          </Modal.Body>
        </Modal>

        {/* Completed Filter */}
        <Modal
          centered
          show={this.state.completedPopup}
          onHide={() => this.completedModal(false)}
          size="lg"
        >
          <Modal.Header className="align-items-center border-bottom px-4 py-3 bg-white">
            <div className="d-flex align-items-center justify-content-between w-100">
              <span className="font-18 font-weight-700 text-dark">{t('completedFilter')}</span>
              <div className="d-flex align-items-center">
                <button
                  type="button"
                  className="btn btn-sm btn-light border font-weight-600 px-3 py-1 mr-2 rounded-pill"
                  onClick={() => this._handleFilterReset("completed")}
                >
                  {t('reset')}
                </button>
                <button
                  type="button"
                  className="btn btn-sm btn-primary font-weight-600 px-4 py-1 mr-3 rounded-pill shadow-sm"
                  style={{ backgroundColor: "#f97316", borderColor: "#f97316" }}
                  onClick={() =>
                    this.debounceFunc(() => {
                      this._handleCompletedFilter();
                    })
                  }
                >
                  {t('apply')}
                </button>
                <X
                  style={{ height: "20px", width: "20px", cursor: "pointer", color: "#64748b" }}
                  onClick={() =>
                    this.setState({
                      completedPopup: false,
                    })
                  }
                />
              </div>
            </div>
          </Modal.Header>
          <Modal.Body className="p-4">
            <div className="nm-filter-modal-custom">
              <style>{`
                .nm-filter-modal-custom .filter-label {
                  font-weight: 600;
                  font-size: 13.5px;
                  color: #334155;
                  margin-bottom: 6px;
                  display: block;
                }
                .nm-filter-modal-custom .risk-chip-container {
                  display: flex;
                  flex-wrap: wrap;
                  gap: 10px;
                  margin-top: 6px;
                  margin-bottom: 18px;
                }
                .nm-filter-modal-custom label.risk-chip {
                  display: inline-flex !important;
                  align-items: center !important;
                  gap: 8px !important;
                  padding: 7px 16px !important;
                  border-radius: 20px !important;
                  border: 1px solid #cbd5e1 !important;
                  background: #f8fafc !important;
                  font-size: 13px !important;
                  font-weight: 500 !important;
                  color: #475569 !important;
                  cursor: pointer !important;
                  user-select: none !important;
                  transition: all 0.2s ease !important;
                  margin-bottom: 0 !important;
                  margin-top: 0 !important;
                }
                .nm-filter-modal-custom label.risk-chip:hover {
                  background: #fff7ed !important;
                  border-color: #fdba74 !important;
                }
                .nm-filter-modal-custom label.risk-chip.active {
                  background: #fff7ed !important;
                  border-color: #f97316 !important;
                  color: #ea580c !important;
                  font-weight: 600 !important;
                  box-shadow: 0 1px 3px rgba(249, 115, 22, 0.2) !important;
                }
                .nm-filter-modal-custom .risk-dot {
                  width: 9px !important;
                  height: 9px !important;
                  border-radius: 50% !important;
                  display: inline-block !important;
                  flex-shrink: 0 !important;
                  margin-right: 8px !important;
                }
                .risk-dot.all { background: #64748b; }
                .risk-dot.extreme { background: #ef4444; }
                .risk-dot.high { background: #f97316; }
                .risk-dot.medium { background: #eab308; }
                .risk-dot.low { background: #22c55e; }
                .nm-filter-modal-custom label:not(.risk-chip),
                .nm-filter-modal-custom .filter-label,
                .nm-filter-modal-custom .slds-form-element__label {
                  font-size: 13.5px !important;
                  font-weight: 600 !important;
                  color: #1e293b !important;
                  margin-bottom: 6px !important;
                  margin-top: 0 !important;
                  display: block !important;
                  letter-spacing: 0.2px;
                }
                .nm-filter-modal-custom select,
                .nm-filter-modal-custom select.form-control,
                .nm-filter-modal-custom select.slds-select,
                .nm-filter-modal-custom .form-control,
                .nm-filter-modal-custom .slds-select,
                .nm-filter-modal-custom .calender-div input {
                  height: 42px !important;
                  min-height: 42px !important;
                  max-height: 42px !important;
                  line-height: 40px !important;
                  border-radius: 8px !important;
                  border: 1px solid #cbd5e1 !important;
                  font-size: 13.5px !important;
                  color: #334155 !important;
                  background-color: #ffffff !important;
                  padding: 0 14px !important;
                  box-sizing: border-box !important;
                  width: 100% !important;
                }
                .nm-filter-modal-custom select,
                .nm-filter-modal-custom select.form-control,
                .nm-filter-modal-custom select.slds-select {
                  padding-right: 32px !important;
                  background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3e%3cpath fill='none' stroke='%2364748b' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='M2 5l6 6 6-6'/%3e%3c/svg%3e") !important;
                  background-repeat: no-repeat !important;
                  background-position: right 12px center !important;
                  background-size: 12px 12px !important;
                  appearance: none !important;
                  -webkit-appearance: none !important;
                  -moz-appearance: none !important;
                }
                .nm-filter-modal-custom select.form-control:focus,
                .nm-filter-modal-custom select.slds-select:focus,
                .nm-filter-modal-custom .form-control:focus,
                .nm-filter-modal-custom .slds-select:focus,
                .nm-filter-modal-custom .calender-div input:focus {
                  border-color: #3b82f6 !important;
                  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.12) !important;
                }
                .nm-filter-modal-custom .calender-div {
                  position: relative;
                }
                .nm-filter-modal-custom .calender-div input {
                  padding-left: 14px !important;
                  padding-right: 38px !important;
                }
                .nm-filter-modal-custom .calender-icon {
                  position: absolute;
                  right: 12px !important;
                  left: auto !important;
                  top: 50%;
                  transform: translateY(-50%);
                  color: #64748b;
                  width: 16px;
                  height: 16px;
                  pointer-events: none;
                }
                .nm-filter-modal-custom .slds-form-element,
                .nm-filter-modal-custom .form-group {
                  margin-bottom: 0 !important;
                }
              `}</style>


              {/* Risk Level - Single Select */}
              <div className="form-group mb-4">
                <label className="filter-label">{t('riskLevel')}</label>
                <div className="risk-chip-container">
                  {[
                    { label: 'Critical', value: 4, dot: 'extreme' },
                    { label: t('high'), value: 3, dot: 'high' },
                    { label: t('medium'), value: 2, dot: 'medium' },
                    { label: t('low'), value: 1, dot: 'low' },
                  ].map(({ label, value, dot }) => (
                    <label
                      key={value}
                      className={`risk-chip ${this.state.completedSeverity === value ? 'active' : ''}`}
                      onClick={() => this.setState({ completedSeverity: this.state.completedSeverity === value ? '' : value })}
                      style={{ cursor: 'pointer' }}
                    >
                      <span className={`risk-dot ${dot}`}></span>
                      <span>{label}</span>
                    </label>
                  ))}
                </div>
              </div>


              {/* Company, Service, Project Category, Plant/Project/Client */}
              <div className="form-group mb-3">
                <Row>
                  {this.state.orgSettings?.company && (
                    <Col sm={6} className="mb-3">
                      <CompanyList
                        optionList={(this.state.companyList || []).map((item) => ({
                          companyId: item.id || item.company_id || item.companyId,
                          companyName: item.company_name || item.name || item.companyName,
                        }))}
                        onChangeHandle={(val) => {
                          this.setState({ completedCompanySelect: val, completedServiceSelect: "", completedProjectSelect: "" });
                          this._fetchServiceForSection(val, "completed");
                        }}
                        value={this.state.completedCompanySelect}
                        isRquired={false}
                        titleview={true}
                      />
                    </Col>
                  )}
                  <Col sm={6} className="mb-3">
                    <label className="filter-label">Service</label>
                    <select
                      className="form-control"
                      value={this.state.completedServiceSelect}
                      onChange={this._handleCompletedServiceChange}
                    >
                      <option value="">Select Service</option>
                      {this.state.completedService.map((service, index) => (
                        <option key={index} value={service.service_id}>
                          {service.service_name}
                        </option>
                      ))}
                    </select>
                  </Col>
                  {this.state.orgSettings?.category && (
                    <Col sm={6} className="mb-3">
                      <CommonDropdown
                        title={"Project Category"}
                        customPlaceHolder={"Project Category"}
                        optionList={(() => {
                          const list = this.state.categoryList || [];
                          let filtered = list;
                          if (this.state.completedServiceSelect) {
                            const selectedService = (this.state.completedService || []).find(
                              (s) => String(s.streamId || s.serviceId || s.service_id || s.id) === String(this.state.completedServiceSelect)
                            );
                            const selectedServiceName = selectedService
                              ? (selectedService.streamName || selectedService.serviceName || selectedService.service_name || selectedService.name)
                              : "";
                            filtered = list.filter((c) => {
                              const cServiceId = c.stream_id || c.service_id || c.serviceId || c.streamId || c.service?.id || c.service?.streamId || c.service?.serviceId;
                              const matchId = cServiceId && String(cServiceId) === String(this.state.completedServiceSelect);
                              const cServiceName = c.service_name || c.serviceName || c.streamName || c.service?.service_name || c.service?.name;
                              const matchName = selectedServiceName && cServiceName && String(cServiceName).toLowerCase() === String(selectedServiceName).toLowerCase();
                              return matchId || matchName;
                            });
                          }
                          const source = filtered.length > 0 ? filtered : list;
                          const uniqueMap = new Map();
                          source.forEach((item) => {
                            const id = item.id || item.sub_vertical_id || item.project_category_id;
                            const name = item.name || item.sub_vertical_name || item.project_category_name || item.title;
                            if (id && name && !uniqueMap.has(id)) {
                              uniqueMap.set(id, { id, name });
                            }
                          });
                          return Array.from(uniqueMap.values());
                        })()}
                        onChangeHandle={(e) => {
                          const val = e && e.target ? e.target.value : e;
                          this.setState({ completedCategorySelect: val });
                        }}
                        isRequired={false}
                        titleview={true}
                        value={this.state.completedCategorySelect}
                      />
                    </Col>
                  )}
                  <Col sm={6} className="mb-3">
                    <label className="filter-label">Plant / Project / Client</label>
                    <select
                      className="form-control"
                      value={this.state.completedProjectSelect}
                      onChange={(e) => {
                        this.setState({
                          completedProjectSelect: e.target.value,
                        });
                      }}
                    >
                      <option value="">Select Plant / Project / Client</option>
                      {this.state.completedProject.map((project, index) => (
                        <option key={index} value={project.project_id}>
                          {project.project}
                        </option>
                      ))}
                    </select>
                  </Col>
                </Row>
              </div>

              {/* Date Range */}
              <div className="form-group mb-2">
                <label className="filter-label">By Report Date</label>
                <Row className="align-items-center">
                  <Col sm={5}>
                    <div className="calender-div">
                      <DatePicker
                        selected={this.state.completedStartDate}
                        onChange={(jsDate) =>
                          this.setState({ completedStartDate: jsDate })
                        }
                        maxDate={new Date()}
                        placeholderText={t('selectStartDate')}
                      />
                      <Calendar className="calender-icon" />
                    </div>
                  </Col>
                  <Col sm={2} className="text-center font-weight-600 text-muted">
                    {t('to')}
                  </Col>
                  <Col sm={5}>
                    <div className="calender-div">
                      <DatePicker
                        selected={this.state.completedEndDate}
                        onChange={(jsDate) =>
                          this.setState({ completedEndDate: jsDate })
                        }
                        minDate={this.state.completedStartDate}
                        maxDate={new Date()}
                        placeholderText={t('selectEndDate')}
                      />
                      <Calendar className="calender-icon" />
                    </div>
                  </Col>
                </Row>
              </div>
            </div>
          </Modal.Body>
        </Modal>
        <Modal centered show={this.state.videoUrl !== ""}>
          <Modal.Header
            closeButton
            onClick={() => this.setState({ videoUrl: "" })}
          >
            <Modal.Title>{t('evidence')}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <VideoBox url={this.state.videoUrl} />
          </Modal.Body>
        </Modal>
        {!!this.state.lightboxactive && (
          <FsLightbox
            toggler={this.state.fsToggler}
            types={this.state.evidencelightboxType}
            disableLocalStorage={true}
            sources={this.state.evidencelightbox}
          />
        )}
        <NmListHelpDrawer />
      </>
    );
  }
};

export default withTranslation('nm')(NmListV2);

